var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.enabled && _vm.isLoggedIn)?_c('TixMessage',{staticClass:"logged-in members-banner",attrs:{"plain":_vm.welcomeMessage,"type":"success"}}):(_vm.enabled)?_c('TixMessage',{staticClass:"logged-out members-banner",attrs:{"template":_vm.promoMessage,"type":"user"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }